import React, { useState, useEffect } from 'react';
import { Dialog } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import { coursesApi } from '../../../../../../../services/api/courses.api';

const AddQuizModal = ({ isOpen, onClose, onAdd, courseId }) => {
  const [quizType, setQuizType] = useState('new'); // new or existing
  const [existingExams, setExistingExams] = useState([]);
  const [selectedExamId, setSelectedExamId] = useState('');

  // جلب الاختبارات الموجودة عند فتح المودال
  useEffect(() => {
    if (isOpen && courseId && quizType === 'existing') {
      fetchExistingExams();
    }
  }, [isOpen, courseId, quizType]);

  // جلب الاختبارات الخاصة بالدورة المحددة
  const fetchExistingExams = async () => {
    try {
      // جلب جميع اختبارات الدورة
      const response = await coursesApi.getExams({ course_id: courseId, filter_unavailable: true });
      
      // التحقق من شكل البيانات المستلمة
      const exams = Array.isArray(response) ? response : (response.data || []);
      // تم جلب الاختبارات بنجاح
      
      setExistingExams(exams);
    } catch (error) {
      // معالجة خطأ جلب الاختبارات
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (quizType === 'new') {
      onAdd({ type: 'new' });
    } else if (selectedExamId) {
      onAdd({ type: 'existing', examId: selectedExamId });
    }
    
    // إعادة تعيين الحالة
    setQuizType('new');
    setSelectedExamId('');
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-50 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen p-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white dark:bg-gray-800 rounded-lg max-w-md w-full">
          {/* رأس النافذة */}
          <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
            <Dialog.Title className="text-lg font-medium text-gray-900 dark:text-white">
              إضافة اختبار جديد
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>

          {/* محتوى النافذة */}
          <form onSubmit={handleSubmit} className="p-4">
            <div className="space-y-4">
              {/* نوع الاختبار */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  نوع الاختبار
                </label>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="new"
                      checked={quizType === 'new'}
                      onChange={(e) => setQuizType(e.target.value)}
                      className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                    />
                    <span className="mr-2 text-sm text-gray-700 dark:text-gray-300">
                      إنشاء اختبار جديد
                    </span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="existing"
                      checked={quizType === 'existing'}
                      onChange={(e) => setQuizType(e.target.value)}
                      className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                    />
                    <span className="mr-2 text-sm text-gray-700 dark:text-gray-300">
                      استخدام اختبار موجود
                    </span>
                  </label>
                </div>
              </div>

              {quizType === 'existing' && (
                <div>
                  <label
                    htmlFor="existingQuiz"
                    className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  >
                    اختر من الاختبارات الموجودة
                  </label>
                  <select
                    id="existingQuiz"
                    value={selectedExamId}
                    onChange={(e) => setSelectedExamId(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    required
                  >
                    <option value="">اختر اختباراً...</option>
                    {existingExams.map((exam) => (
                      <option key={exam.id} value={exam.id}>
                        {exam.title}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            {/* أزرار التحكم */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
              >
                إلغاء
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {quizType === 'new' ? 'إنشاء' : 'إضافة'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};

export default AddQuizModal;
